// App.js
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./AppRoutes"; // We'll create this
import { ToastContainer } from "react-toastify";


function App() {
  return (
    <Router>
      <AppRoutes />
      <ToastContainer />
    </Router>
  );
}

export default App;
